/* eslint-disable */
import Swiper, { Navigation, Pagination } from 'swiper';
import Masonry from 'masonry-layout';
import { gsap } from "gsap";

export default {
  init() {
    // JavaScript to be fired on all pages

    /**
     * Mobile menu
    */
    var menuAnimation = (function () {
      var executed = false;
      return function () {
        if (!executed) {
          executed = true;
          const aniFromMenu = $('.brush--menu').offset().left + 50;
          gsap.from(".brush--menu", { x: `-${aniFromMenu}px`, duration: 1.8, delay: .3, });
        }
      };
    })();

    $('.mobile-hamburger-icon').on('click', function () {
      $('.mobile-hamburger-icon').toggleClass('mobile-hamburger-icon--active');
      $('.mobile-menu').toggleClass('mobile-menu--active');
      $('.site-header').toggleClass('site-header--active');
      $('.replacement-block').toggleClass('replacement-block--active');

      menuAnimation();
    })

    if ($('.hero-swiper').length) {

      Swiper.use([Navigation, Pagination]);

      new Swiper('.hero-swiper', {
        slidesPerView: 1,
        loop: true,
        navigation: {
          nextEl: '.hero-swiper-next',
        },
        pagination: {
          el: '.hero-swiper-pagination',
          type: 'fraction',
        },
      });
    }


    if ($('.projecten-swiper').length) {

      Swiper.use([Navigation, Pagination]);

      new Swiper('.projecten-swiper', {
        slidesPerView: 1.5,
        spaceBetween: 23,
        loop: true,
        centeredSlides: true,
        navigation: {
          nextEl: '.projecten-swiper-next',
          prevEl: '.projecten-swiper-prev',
        },
        pagination: {
          el: '.projecten-swiper-pagination',
          type: 'fraction',
        },
      });
    }

    const msnry = () => {
      new Masonry('.archive-projecten__grid', {
        columnWidth: '.grid-sizer',
        itemSelector: '.archive-projecten__grid-item',
        percentPosition: true,
        gutter: '.gutter-sizer',
      });
    }

    if ($('.archive-projecten__grid').length) {
      msnry();
    }



    $('#filter').on('change', () => {
      var filter = $('#filter');
      $.ajax({
        url: filter.attr('action'),
        data: filter.serialize(), // form data
        type: filter.attr('method'), // POST
        beforeSend: function () {
          $('#response').css('opacity', '0.6');
          //$('#archive_videos_container').css('cursor', 'not-allowed');
        },
        success: function (data) {
          $('#response').css('opacity', '1');
          //$('#archive_videos_container').css('cursor', 'context-menu');
          $('#response').html(data); // insert data
          msnry();
        },
      });
      return false;
    });

    if ($('.image-swiper').length) {
      new Swiper('.image-swiper', {
        slidesPerView: "auto",
        spaceBetween: 25,
        loop: true,
        breakpoints: {
          768: {
            spaceBetween: 85,
          },
        },
      });
    }

    if ($('.hero-small').length) {
      const aniFrom = $('.brush').offset().left + 50;
      gsap.from(".brush", { x: `-${aniFrom}px`, duration: 3 });
    }

    if ($('.hero-big').length) {
      const aniFrom = $('.brush').offset().left + 50;
      gsap.from(".brush", { x: `-${aniFrom}px`, duration: 2.2 });
    }


    if ($('.video-full').length) {
      $('.playbutton').on('click', () => {
        $('.main_video').trigger('play')
        $('.playbutton').addClass('playing')
        $('.playlink').addClass('playing')
      })
      $('.main_video').on('click', () => {
        $('.main_video').trigger('pause')
        $('.playbutton').removeClass('playing')
        $('.playlink').removeClass('playing')
      })
    }

    $('.count').each(function (index) {
      $(this).html(`00${index + 1}`);
    });


  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js